import { getAuthContext } from '../context/AuthContext';

const getAxios = () => getAuthContext().axiosInstance;

const resolveEmpresaId = async () => {
    const { user } = getAuthContext();

    if (user?.idEmpresa) {
        return user.idEmpresa;
    }

    if (user?.idSucursal) {
        const sucursalResponse = await getAxios().get(`/api/sucursales/${user.idSucursal}`);
        return sucursalResponse.data?.data?.idEmpresa ?? 1;
    }

    return 1;
};

export const CategoriaService = {
    getAll: async () => {
        const idEmpresa = await resolveEmpresaId();
        const response = await getAxios().get(`/api/categorias/empresa/${idEmpresa}`);
        return response.data;
    },
    
    create: async (categoria) => {
        const response = await getAxios().post('/api/categorias', categoria);
        return response.data;
    },

    update: async (id, categoria) => {
        const response = await getAxios().put(`/api/categorias/${id}`, categoria);
        return response.data;
    },

    delete: async (id) => {
        const response = await getAxios().delete(`/api/categorias/${id}`);
        return response.data;
    }
};
